module.exports = __webpack_public_path__ + "img/search.21cf1515.svg";